import React, { useState } from 'react';

export default function PerfilModal({ initialNombre, initialAvatar, initialNota, initialPrivacidad, onSave, onClose, loading, mobile }) {
  const [nombre, setNombre] = useState(initialNombre || '');
  const [avatar, setAvatar] = useState(initialAvatar || '');
  const [nota, setNota] = useState(initialNota || '');
  const [privada, setPrivada] = useState(initialPrivacidad === false ? false : true);
  const [error, setError] = useState(null);

  // Permitir cargar imagen desde archivo
  const handleAvatarFile = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = ev => setAvatar(ev.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSave = () => {
    if (!nombre.trim()) {
      setError('El nombre no puede estar vacío.');
      return;
    }
    setError(null);
    onSave({ nombre, avatar, nota, privada });
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        padding: mobile ? 18 : 32,
        minWidth: mobile ? 0 : 340,
        width: mobile ? '92vw' : 360,
        maxWidth: 400,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}>
        <h2 style={{ color: '#0099cc', marginBottom: 14, fontSize: mobile ? 18 : 22 }}>Editar perfil y notas</h2>
        <label style={{ marginBottom: 10, fontWeight: 600, fontSize: mobile ? 14 : 16 }}>Nombre</label>
        <input
          type="text"
          value={nombre}
          onChange={e => setNombre(e.target.value)}
          style={{
            borderRadius: 8,
            border: '1px solid #b0bec5',
            padding: 10,
            fontSize: mobile ? 15 : 16,
            marginBottom: 12
          }}
          placeholder="Tu nombre"
        />
        <label style={{ marginBottom: 10, fontWeight: 600, fontSize: mobile ? 14 : 16 }}>Avatar</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleAvatarFile}
          style={{ marginBottom: 10 }}
        />
        {avatar && (
          <img src={avatar} alt="Avatar preview" style={{ width: 70, height: 70, borderRadius: '50%', objectFit: 'cover', marginBottom: 12, border: '2px solid #0099cc', alignSelf: 'center' }} />
        )}
        <label style={{ marginBottom: 10, fontWeight: 600, fontSize: mobile ? 14 : 16 }}>Notas personales</label>
        <textarea
          value={nota}
          onChange={e => setNota(e.target.value)}
          rows={mobile ? 4 : 5}
          style={{
            borderRadius: 8,
            border: '1px solid #b0bec5',
            padding: 12,
            fontSize: mobile ? 15 : 16,
            marginBottom: 12,
            resize: 'vertical'
          }}
          placeholder="Escribe tus notas aquí..."
        />
        <label style={{ marginBottom: 12, display: 'flex', alignItems: 'center', fontSize: mobile ? 13 : 15 }}>
          <input
            type="checkbox"
            checked={privada}
            onChange={e => setPrivada(e.target.checked)}
            style={{ marginRight: 8 }}
          />
          Permitir que mi neuroterapeuta y superadmin vean estas notas
        </label>
        {error && <div style={{ color: '#e53935', marginBottom: 8 }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            onClick={onClose}
            style={{
              background: '#b0bec5',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: mobile ? '8px 16px' : '10px 20px',
              fontSize: mobile ? 14 : 15,
              cursor: 'pointer'
            }}
            disabled={loading}
          >Cancelar</button>
          <button
            onClick={handleSave}
            style={{
              background: '#0099cc',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: mobile ? '8px 16px' : '10px 20px',
              fontSize: mobile ? 14 : 15,
              fontWeight: 600,
              cursor: 'pointer'
            }}
            disabled={loading}
          >{loading ? 'Guardando...' : 'Guardar'}</button>
        </div>
      </div>
    </div>
  );
}
